export enum NewCertificateTab {
  General,
  Ratings,
  SystemInfo,
}
